<template>
  <province-city-district
    :value="value"
    :list="list"
    v-bind="$attrs"
    ref="select"
  ></province-city-district>
</template>

<script>
  import proxy from './proxy'
  import { districtMapFromCityLabel } from './china-area-data'
  import provinceCityDistrict from './base'

  export default {
    name: 'District',
    inheritAttrs: false,
    mixins: [proxy],
    props: {
      value: [String, Number],
      city: String
    },
    computed: {
      list () {
        return districtMapFromCityLabel[this.city]
      }
    },
    components: {
      provinceCityDistrict
    }
  }
</script>
